import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { Uygulama } from './Uygulama';
import './index.css';

const kok = document.getElementById('kok');

// Kök bulunamazsa sessizce boş sayfa yerine açık hata verilir; sebebi
// index.html'de kimlik değişmiş olmasıdır ve sessiz kalırsa saatler kaybolur.
if (!kok) throw new Error('#kok bulunamadı — index.html ile main.tsx uyuşmuyor.');

createRoot(kok).render(
  <StrictMode>
    <Uygulama />
  </StrictMode>,
);
